import Header from "../../../components/layouts/header";
import Sidebar from "../../../components/layouts/sidebar";
import { APIRoutes } from "../../../utility/app-routes";
import { MasterCommonRecordPage } from "../../../components/common/common-master-record/master-common-record-page";

const Building: React.FC = () => {
	// Table Pagination

	return (
		<div className="page-inner">
			<>
				<MasterCommonRecordPage
					addUpdateApiUrl={APIRoutes.appUpdateBuilding}
					deleteApiUrl={APIRoutes.deleteBuilding}
					title="Building"
					getAllRecordApiUrl={APIRoutes.getAllBuilding}
				/>
			</>
		</div>
	);
};
export default Building;
